import { Injectable } from '@angular/core';
import { HttpClientService } from '../../client/http-client/http-client.service';
import { ApiConstants } from '../../constants/api.constants';
import { map } from 'rxjs';
import { EmployeeRoot } from '../../domain/employee-domain';

@Injectable({
  providedIn: 'root',
})
export class EmployeeService {
  constructor(private httpClient: HttpClientService) {}

  fetchEmployeeList() {
    return this.httpClient.get<EmployeeRoot>(ApiConstants.EMPLOYEE_LIST_API_URL).pipe(map((res) => res));
  }
}
